var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2622_190064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 1.83301C10.6455 1.83301 13.3335 4.52101 13.3335 7.83301C13.3335 11.145 10.6455 13.833 7.3335 13.833C4.0215 13.833 1.3335 11.145 1.3335 7.83301C1.3335 4.52101 4.0215 1.83301 7.3335 1.83301ZM7.3335 12.4997C9.9115 12.4997 12.0002 10.411 12.0002 7.83301C12.0002 5.25434 9.9115 3.16634 7.3335 3.16634C4.75483 3.16634 2.66683 5.25434 2.66683 7.83301C2.66683 10.411 4.75483 12.4997 7.3335 12.4997ZM12.9902 12.547L14.8762 14.4323L13.9328 15.3757L12.0475 13.4897L12.9902 12.547Z",
    fill: "#67667A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2622_190064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSearchIcon);
export default __webpack_public_path__ + "static/media/table-search-icon.01dfc6a10a00bd0cd0639ec3ff3fe980.svg";
export { ForwardRef as ReactComponent };